import { rootApi } from "..";
import { conveyanceService } from "../../../Api/Services/ConveyanceService";
import { makeEndpoints } from "../../../utils/rtkQueryFactory";

const conveyanceEndpoints = [
  {
    name: "listConveyance",
    type: "query",
    serviceFn: ({
      user,
      startDate,
      endDate,
      activeYear,
      page,
      size,
    }: {
      user: string;
      startDate?: string;
      endDate?: string;
      activeYear?: number;
      page?: number;
      size?: number;
    }) =>
      conveyanceService.getConveyanceDetails(
        user,
        startDate,
        endDate,
        activeYear,
        page,
        size
      ),
    tagType: "ConveyanceInfo",
  },
  {
    name: "addConveyance",
    type: "mutation",
    serviceFn: (applyConveyanceFormData: FormData) =>
      conveyanceService.applyConveyance(applyConveyanceFormData),
  },
  {
    name: "deleteConveyance",
    type: "mutation",
    serviceFn: ({ id }: { id: number }) =>
      conveyanceService.deleteConveyance({ id }),
    tagType: "ConveyanceInfo",
  },
] as const;

export const conveyanceApi = rootApi.injectEndpoints({
  endpoints: (builder) => makeEndpoints(builder, conveyanceEndpoints),
});

export const {
  useListConveyanceQuery,
  useAddConveyanceMutation,
  useDeleteConveyanceMutation,
} = conveyanceApi;
